import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Setup console behavior (silence or route logs) before importing the app
import './setupConsole'
import App from './App.tsx'
import './styles/globals.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
